export default __webpack_public_path__ + "static/media/showcase-question-mark.5300501d.jpg";